<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'ADSExceptionRecord',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'aDSExceptionRecord:add',
        update: 'aDSExceptionRecord:update',
        delete: 'aDSExceptionRecord:delete',
        deleteBatch: 'aDSExceptionRecord:deleteBatch'
      },
      url: {
        get: '/aDSExceptionRecord/listByCondition',
        add: '/aDSExceptionRecord/add',
        update: '/aDSExceptionRecord/update',
        delete: '/aDSExceptionRecord/delete',
        delete_batch: '/aDSExceptionRecord/deleteBatch',
        status: '/aDSExceptionRecord/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },
        {
          field: 'aDSEnvironmentId',  // 字段名
          label: 'ADS环境表ID',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'environmentName',  // 字段名
          label: '环境名称',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'environmentRemark',  // 字段名
          label: '环境备注',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'callBack',  // 字段名
          label: '回调日志',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'videoTitle',  // 字段名
          label: '视频标题',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'thumbnailPath',  // 字段名
          label: '视频封面',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          img: true
        }, {
          field: 'actualPublishTime',  // 字段名
          label: '发布时间',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },{
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          },
          {
            field: 'aDSEnvironmentId',  // 字段名
            label: 'aDSEnvironmentId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入aDSEnvironmentId',
            rules: [
              {required: true, message: 'aDSEnvironmentId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'callBack',  // 字段名
            label: 'callBack',  // 字段显示名称
            type: 'input',
            placeholder: '请输入callBack',
            rules: [
              {required: true, message: 'callBack不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'videoTitle',  // 字段名
            label: 'videoTitle',  // 字段显示名称
            type: 'input',
            placeholder: '请输入videoTitle',
            rules: [
              {required: true, message: 'videoTitle不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'thumbnailPath',  // 字段名
            label: 'thumbnailPath',  // 字段显示名称
            type: 'input',
            placeholder: '请输入thumbnailPath',
            rules: [
              {required: true, message: 'thumbnailPath不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'actualPublishTime',  // 字段名
            label: 'actualPublishTime',  // 字段显示名称
            type: 'input',
            placeholder: '请输入actualPublishTime',
            rules: [
              {required: true, message: 'actualPublishTime不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
